var map = {
	"./010.jpg": 5952,
	"./016.jpg": 6054,
	"./03.jpg": 6096,
	"./05.jpg": 4790,
	"./08.jpg": 7271,
	"./3.jpg": 3232,
	"./8.jpg": 9975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5297;